import { Icon, Logo } from './Icon';
import { useCategoryLook } from './pickers';

/**
 * Объявление без фото: фирменная карточка — цвет и значок категории, знак и название маркета.
 * Выглядит аккуратно в ленте и при пересылке скриншота напоминает, где это найдено.
 */
export function ListingPlaceholder({ categoryId, large }: { categoryId: string | null | undefined; large?: boolean }) {
  const look = useCategoryLook(categoryId);
  return (
    <div className={`listing-ph ${large ? 'listing-ph-lg' : ''}`} style={{ '--tone': look?.tone ?? '#2fd27a' } as React.CSSProperties} aria-hidden>
      <span className="listing-ph-icon">
        <Icon name={look?.icon ?? 'grid'} size={large ? 64 : 40} strokeWidth={1.5} />
      </span>
      <span className="listing-ph-brand">
        <Logo size={large ? 20 : 14} />
        <span>Qaraqalpaq Market</span>
      </span>
    </div>
  );
}
